import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';

export default function ShareModal({
  showShareModal,
  setShowShareModal,
  countryCode,
  setCountryCode,
  whatsappNumber,
  setWhatsappNumber,
  isSending,
  handleSendWhatsapp,
}) {
  if (!showShareModal) return null;
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/40 z-[99999]">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white rounded-2xl shadow-2xl p-8 w-[400px] animate-fadeIn">
        <h2 className="text-xl font-bold text-gray-800 mb-4 text-center">Share & Export Summary</h2>
        <div className="flex items-center gap-2 mb-6">
          <InputText value={countryCode} onChange={(e) => setCountryCode(e.target.value)} placeholder="+91" className="w-20 text-center font-semibold" />
          <InputText value={whatsappNumber} onChange={(e) => setWhatsappNumber(e.target.value)} placeholder="Enter WhatsApp number" className="flex-1" />
        </div>
        <div className="flex justify-center gap-4">
          <Button label={isSending ? "Sending..." : "Send"} icon="pi pi-send" className="p-button-sm bg-green-600 hover:bg-green-700 text-white px-5 rounded-xl" onClick={handleSendWhatsapp} disabled={isSending} />
          <Button label="Cancel" className="p-button-sm p-button-outlined border-2 text-gray-600 hover:bg-gray-50 rounded-xl" onClick={() => setShowShareModal(false)} />
        </div>
        <button onClick={() => setShowShareModal(false)} className="absolute top-3 right-3 text-gray-400 hover:text-gray-600">
          <i className="pi pi-times text-xl"></i>
        </button>
      </div>
    </div>
  );
}